import { Component } from '@angular/core';
import { URLS } from '../../shared/constant/interface';
import { _MSGTYPES, MSG_CONTENT_TYPE } from '../../shared/constant/msgType';
import { MsgTemplateDetail } from '../../msg-interface/msg-template-detail';

@Component({
  selector: 'icc-tiktok-tpl-detail',
  templateUrl: './tiktok-tpl-detail.component.html',
  styleUrls: ['./tiktok-tpl-detail.component.less'],
})
export class TiktokTplDetailComponent implements MsgTemplateDetail {
  constructor() {}
  SCENE = 'icc-msg-tpl-detail';
  MSG_TYPE = _MSGTYPES.MT;
  _MSG_CONTENT_TYPE = MSG_CONTENT_TYPE;

  data;

  fileBaseUrl: string;

  type: number = _MSGTYPES.MT.TIKTOK.type;

  setData(item): void {
    this.data = item;
    // console.log('this.data :>> ', this.data);
    this.fileBaseUrl = URLS.attachment.url + '?';
    for (let item of this.data.templates) {
      if (item.content.contentType === 3 || item.content.contentType === 4) {
        for (let media of item.content.mediaList) {
          media.url = this.fileBaseUrl + media.url;
        }
      }
    }
  }
}
